/** Shared CTA + title copy for OHLC resolve / setup dialogs. */
export const MARKET_DATA_RESOLVE_DIALOG_COPY = {
  cancel: "Cancel",
  confirmMarketDataSource: "Confirm market data source",
  saveAndContinue: "Save and continue",
  confirmQuoteVariant: "Confirm quote variant",
  saveOhlcSource: "Confirm market data source",
} as const;
